import React from 'react'
import { Link } from 'react-router-dom'

const DateAndTime = ({data,selectedRecurence,setRecurrence}) => {
    const boxStyle = selectedRecurence.id === data.id
    ? { border: "2px solid brown" }
    : {};

  return (
    
    <div className="SingleBox sm:w-[50vw] lg:w-[20vw] border rounded overflow-hidden inline-block shadow-lg p-6 m-2"  style={boxStyle} onClick={(e)=>{setRecurrence(e,data)}}>
    <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-semibold">{data?.day}</h3>
        { data.status && <span class="px-2 py-1 rounded-full text-white bg-green-500">{data.status}</span>}   
    </div>
    <div class="mb-4">
        <p class="text-sm text-gray-700 whitespace-normal"><strong>Start Time:</strong> {data?.start_time?new Date(data?.start_time).toLocaleString(): "Not specified"}</p>
        <p class="text-sm text-gray-700 whitespace-normal"><strong>End Time:</strong>{data?.end_time?new Date(data?.end_time).toLocaleString(): "Not specified"}</p>
    </div>
    <div class="flex space-x-4">
        <Link to={data?.tickets_url} class="text-sm bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Buy Tickets</Link>
        <Link to={data?.source_page_url} class="text-sm bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">More Info</Link>
    </div>
                </div>
  )
}

export default DateAndTime
